import { PropertyType } from '@/models/property.model';

export enum PricesFormValues {
  APPRAISER_PRICE = 'appraiserPrice',
  PRICE = 'price',
  NAME_EN = 'name_en',
  NAME_NO = 'name_no',
  FROM = 'from_area',
  TO = 'to_area',
  DESCRIPTION_EN = 'description_en',
  DESCRIPTION_NO = 'description_no',
  PROPERTY_TYPE = 'property_type',
}

export type TPhotoShootingFormValues = {
  [PricesFormValues.NAME_EN]: string;
  [PricesFormValues.NAME_NO]: string;
  [PricesFormValues.FROM]: number;
  [PricesFormValues.TO]: number;
  [PricesFormValues.PRICE]: number;
  [PricesFormValues.DESCRIPTION_EN]: string;
  [PricesFormValues.DESCRIPTION_NO]: string;
  [PricesFormValues.PROPERTY_TYPE]: PropertyType;
};

export type TSettlementFormValues = {
  [PricesFormValues.NAME_EN]: string;
  [PricesFormValues.NAME_NO]: string;
  [PricesFormValues.DESCRIPTION_EN]: string;
  [PricesFormValues.DESCRIPTION_NO]: string;
};

export type TAppraiserFormValues = {
  [PricesFormValues.NAME_EN]: string;
  [PricesFormValues.NAME_NO]: string;
  [PricesFormValues.FROM]: number;
  [PricesFormValues.TO]: number | null;
  [PricesFormValues.PRICE]: number;
  [PricesFormValues.DESCRIPTION_EN]: string;
  [PricesFormValues.DESCRIPTION_NO]: string;
  [PricesFormValues.PROPERTY_TYPE]: PropertyType;
};
